import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FcmState {
  token: string | null;
}

const initialState: FcmState = {
  token: null,
};

const FcmSlice = createSlice({
  name: 'fcm',
  initialState,
  reducers: {
    setFcmToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
    clearFcmToken: (state) => {
      state.token = null;
    },
  },
});

export const { setFcmToken, clearFcmToken } = FcmSlice.actions;
export default FcmSlice.reducer; 